import { ActionItem } from "@/http";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const filterClientActionId = (key: string, actions: ActionItem[]) => {
  return actions.find((item) => item.name.includes(key)) as ActionItem;
};

export function getAvatarFallback(appName: string | undefined) {
  if (!appName) {
    return "AD"; // Default fallback for empty or undefined appName
  }

  return appName
    .split(/[\s-]+/) // Split by spaces or hyphens
    .map((word) => word[0]) // Take the first letter of each word
    .join("") // Combine the initials
    .slice(0, 2) // Ensure only the first two characters
    .toUpperCase(); // Convert to uppercase
}
